<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
        </div>
        <div class="work_order_add_container mobile_container custom_mobile_form" v-loading="loading">
            <van-form
                label-width="9.5em"
                input-align="right"
                scroll-to-error
                :show-error-message="false"
                :rules="workOrderTransferFormRules"
                ref="workOrderTransferForm"
                class=""
            >
                <van-field
                    v-model="workOrderTransferForm.new_processing_uid_text"
                    name="new_processing_uid"
                    label="将工单转移给"
                    placeholder="请选择"
                    error-message-align="right"
                    is-link
                    readonly
                    @click="handleClickProcessingUidsFieldlink"
                >
                </van-field>
            </van-form>
        </div>
        <div class="add_footer_wrap mobile_add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
        <!-- 实施人员选择 -->
        <UserSelect
            :userSelectVisible.sync="userSelectVisible"
            :userSelectTitle="'选择人员'"
            :allUserList="processingUserList"
            @selectUserData="handleSelectUserData"
            v-if="userSelectVisible"
        />
    </div>
</template>
<script>
import { roleDetail, transferProcessing } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSelect from "./component/user_select.vue";
import {EventBus} from '@/utils/eventBus';
export default {
    name: "WorkOrderTransfer",
    components: { ReturnNavBar, UserSelect },
    data() {
        return {
            loading: false,
            workorder_id: this.$route.query.id,
            processing_users_selected_ids: this.$route.query.processing_user_ids || [], // 已经选择过的实施人员的id
            workOrderTransferForm: {
                new_processing_uid: "",
                new_processing_uid_text: "",
            },
            workOrderTransferFormRules: {},

            processingUserList: [], // 可以选择的
            userSelectVisible: false,

            btnDisabled: false,
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        owner_uid() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.id;
        },
    },
    created() {
        this.getRoleDetail()
    },
    methods: {
        handleClickProcessingUidsFieldlink() {
            this.userSelectVisible = true;
        },
        // 获取后台已经配置的角色人员
        getRoleDetail() {
            roleDetail({
                role_type: "processing_user",
            }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    const selectedUids = this.processing_users_selected_ids || []
                    // 从实施角色中的全部未被选择人员中选择，排除掉当前工单已经选择过的
                    const processingUserList = data.filter((item) => !selectedUids.includes(item.id));
                    this.processingUserList = processingUserList;
                }
            });
        },
        // 选择实施人员确认
        handleSelectUserData(data) {
            this.$set(this.workOrderTransferForm, "new_processing_uid", data.id);
            this.$set(this.workOrderTransferForm, "new_processing_uid_text", data.name);
        },
        handleClickConfirm() {
            this.$refs.workOrderTransferForm.validate().then(() => {
                if (!this.workOrderTransferForm.new_processing_uid) return;
                const params = {
                    workorder_id: this.workorder_id,
                    old_processing_uid: this.owner_uid,
                    new_processing_uid: this.workOrderTransferForm.new_processing_uid,
                };
                this.btnDisabled = true;
                transferProcessing(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    EventBus.$emit('workOrderAddUpdated');
                                    this.$router.go(-1);
                                    this.btnDisabled = false;
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
}
</style>
